/* eslint-disable */
document.addEventListener('DOMContentLoaded', () => {
	const atsCurrentOpenings = document.querySelectorAll('.ats-current-opening-dropdown.item');
	atsCurrentOpenings.forEach(atsCurrentOpening => {
		const atsOpeningContainer = atsCurrentOpening.querySelector('.opening-container');
		atsOpeningContainer.addEventListener('click', () => {
			const clsIna = atsCurrentOpening.querySelector('.detail-container').classList;
			if (clsIna.contains('inactive')) {
				atsCurrentOpening.querySelector('.detail-container').classList.remove('inactive');
				atsCurrentOpening.querySelector('.carat-sign').classList.add('open');
				atsCurrentOpening.classList.add('open-dropdown');
				const dataAttributeValue = atsCurrentOpening.getAttribute('data-position-code');
				// fetchDataAndUpdateUI(dataAttributeValue);
			} else {
				atsCurrentOpening.querySelector('.detail-container').classList.add('inactive');
				atsCurrentOpening.querySelector('.carat-sign').classList.remove('open');
				atsCurrentOpening.classList.remove('open-dropdown');
			}
		});
	});

	const cache = {}; // Initialize cache object

	// Function to escape HTML entities
	function escapeHTML(str) {
		const div = document.createElement('div');
		div.appendChild(document.createTextNode(str));
		return div.innerHTML;
	}

	// Function to fetch API data and update UI
	// async function fetchDataAndUpdateUI(dataAttributeValue) {
	// 	const atsApiUrl = await getApiUrl();
	// 	// Check if data is already cached
	// 	if (cache[dataAttributeValue]) {
	// 		// updateUIWithData(dataAttributeValue, cache[dataAttributeValue]);
	// 	} else {
	// 		// Make an AJAX call to fetch data
	// 		const xhr = new XMLHttpRequest();
	// 		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
	// 		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	// 		xhr.onload = function () {
	// 			if (xhr.status === 200) {
	// 				const response = JSON.parse(xhr.responseText);
	// 				if (response && response.data && response.data.response) {
	// 					const decodedJobDescription = decodeHTMLEntities(response.data.response.jobDescription); //eslint-disable-line
	// 					const rolesAndResponsibilities = decodeHTMLEntities(
	// 						response.data.response.rolesAndResponsibilities,
	// 					); //eslint-disable-line
	// 					// Cache the fetched data
	// 					cache[dataAttributeValue] = {
	// 						jobDescription: escapeHTML(decodedJobDescription),
	// 						anotherField: escapeHTML(rolesAndResponsibilities),
	// 					};

	// 					// Update UI with fetched data
	// 					// updateUIWithData(dataAttributeValue, cache[dataAttributeValue]);
	// 				} else {
	// 					console.error('Invalid API response structure.');
	// 				}
	// 			} else {
	// 				console.error('Request failed. Status: ' + xhr.status);
	// 			}
	// 		};

	// 		const data = new URLSearchParams();
	// 		data.append('action', 'ats_fetch_position_details'); // phpcs:ignore.
	// 		data.append('nonce', ajaxload_params.nonce); // phpcs:ignore.
	// 		data.append('position_code', dataAttributeValue); // phpcs:ignore.
	// 		data.append('atsapiurl', atsApiUrl); // phpcs:ignore.
	// 		xhr.send(data);
	// 	}
	// }

	// Function to update UI with data
	function updateUIWithData(dataAttributeValue, data) {
		const targetElement = document.querySelector(
			`.expanded-section[data-position-code="${dataAttributeValue}"]`,
		);
		if (targetElement) {
			const jobDescriptionDiv = document.createElement('span');
			jobDescriptionDiv.className = 'job-description';
			jobDescriptionDiv.innerHTML = decodeHTMLEntities(data.jobDescription); // phpcs:ignore.

			const anotherFieldDiv = document.createElement('span');
			anotherFieldDiv.className = 'another-field';
			anotherFieldDiv.innerHTML = decodeHTMLEntities(data.anotherField); // phpcs:ignore.

			// Clear existing content
			while (targetElement.firstChild) {
				targetElement.removeChild(targetElement.firstChild);
			}

			// Append new content
			targetElement.appendChild(jobDescriptionDiv); // phpcs:ignore.
			targetElement.appendChild(anotherFieldDiv); // phpcs:ignore.
		}
	}

	// Function to decode HTML entities (assuming this function exists in your code)
	function decodeHTMLEntities(str) {
		const txt = document.createElement('textarea');
		txt.innerHTML = str; // phpcs:ignore.
		return txt.value;
	}

	const loadMore = document.querySelector('.load-more');
	if (loadMore) {
		loadMore.addEventListener('click', event => {
			let cnt = 0;
			event.preventDefault();
			while (cnt < 5) {
				const row = document.querySelector('.ats-current-opening-dropdown.inactive');
				if (row !== null) {
					document
						.querySelector('.ats-current-opening-dropdown.inactive')
						.classList.remove('inactive');
				} else {
					console.error("Element with class 'my-class' not found.");
					document.querySelector('.openings-button').classList.add('inactive');
				}
				cnt += 1;
			}
		});
	}

	const atscmbteams = document.getElementById('atscmbteams');
	const atscmbexp = document.getElementById('atscmbexp');
	const atscmbcountry = document.getElementById('atscmbcountry');
	const atsID = document.querySelector('.ats-career-id');

	async function getApiUrl() {
		const apiDeils = await getSecureData(); 
		console.log(apiDeils,"apiDeils");
		
		return apiDeils;
	}

	const atscmbinputs = [atscmbteams, atscmbexp, atscmbcountry, atsID];
	
	atscmbinputs.forEach(cmbdrp => {
		if(cmbdrp){
			cmbdrp.addEventListener('change', function () {
			
				const data = {
					action: 'ats_filter_current_openings',
					nonce: ajaxload_params.nonce,
					teams: atscmbteams.value,
					exp: atscmbexp.value,
					country: atscmbcountry.value,
					hdnAttributes: getApiUrl(),
				};
	
				fetch(ajaxload_params.ajaxurl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					},
					body: new URLSearchParams(data).toString(),
				})
					.then(response => response.json())
					.then(response => {
						if (response) {
							// Update your UI with the response data
							document.querySelector('#inner-html').remove();
							document.querySelector('.medium-uppercase').textContent = '';
							document
								.querySelector('#openings-structure')
								.insertAdjacentHTML('beforeend', response.html);
	
							document
								.querySelector('.medium-uppercase')
								.insertAdjacentHTML('beforeend', response.count_post);
	
							const atsCurrentOpenings = document.querySelectorAll(
								'.ats-current-opening-dropdown.item',
							);
							atsCurrentOpenings.forEach(atsCurrentOpening => {
								const atsOpeningContainer = atsCurrentOpening.querySelector('.opening-container');
								atsOpeningContainer.addEventListener('click', () => {
									const clsIna = atsCurrentOpening.querySelector('.detail-container').classList;
									if (clsIna.contains('inactive')) {
										atsCurrentOpening.querySelector('.detail-container').classList.remove('inactive');
										atsCurrentOpening.querySelector('.carat-sign').classList.add('open');
										atsCurrentOpening.classList.add('open-dropdown');
										const dataAttributeValue = atsCurrentOpening.getAttribute('data-position-code');
										// fetchDataAndUpdateUI(dataAttributeValue);
									} else {
										atsCurrentOpening.querySelector('.detail-container').classList.add('inactive');
										atsCurrentOpening.querySelector('.carat-sign').classList.remove('open');
										atsCurrentOpening.classList.remove('open-dropdown');
									}
								});
							});
	
							const cache = {}; // Initialize cache object
	
							// Function to escape HTML entities
							function escapeHTML(str) {
								const div = document.createElement('div');
								div.appendChild(document.createTextNode(str));
								return div.innerHTML;
							}
	
							// Function to fetch API data and update UI
							// async function fetchDataAndUpdateUI(dataAttributeValue) {
							// 	const atsApiUrl = await getApiUrl();
							// 	// Check if data is already cached
							// 	console.log(atsApiUrl,"sasas");
	
							// 	if (cache[dataAttributeValue]) {
							// 	// updateUIWithData(dataAttributeValue, cache[dataAttributeValue]);
							// 	} else {
									
							// 		// Make an AJAX call to fetch data
							// 		const xhr = new XMLHttpRequest();
							// 		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
							// 		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
							// 		xhr.onload = function () {
							// 			if (xhr.status === 200) {
							// 				const response = JSON.parse(xhr.responseText);
	
							// 				if (response && response.data && response.data.response) {
							// 					const decodedJobDescription = decodeHTMLEntities(
							// 						response.data.response.jobDescription,
							// 					); //eslint-disable-line
							// 					const rolesAndResponsibilities = decodeHTMLEntities(
							// 						response.data.response.rolesAndResponsibilities,
							// 					); //eslint-disable-line
	
							// 					// Cache the fetched data
							// 					cache[dataAttributeValue] = {
							// 						jobDescription: escapeHTML(decodedJobDescription),
							// 						anotherField: escapeHTML(rolesAndResponsibilities),
							// 					};
	
							// 					// Update UI with fetched data
							// 					// updateUIWithData(dataAttributeValue, cache[dataAttributeValue]);
							// 				} else {
							// 					console.error('Invalid API response structure.');
							// 				}
							// 			} else {
							// 				console.error('Request failed. Status: ' + xhr.status);
							// 			}
							// 		};
	
							// 		const data = new URLSearchParams();
							// 		data.append('action', 'ats_fetch_position_details'); // phpcs:ignore.
							// 		data.append('nonce', ajaxload_params.nonce); // phpcs:ignore.
							// 		data.append('position_code', dataAttributeValue); // phpcs:ignore.
							// 		data.append('atsapiurl', atsApiUrl); // phpcs:ignore.
							// 		xhr.send(data);
							// 	}
							// }
	
							// Function to update UI with data
							// function updateUIWithData(dataAttributeValue, data) {
							// 	const targetElement = document.querySelector(
							// 		`.expanded-section[data-position-code="${dataAttributeValue}"]`,
							// 	);
							// 	if (targetElement) {
							// 		const jobDescriptionDiv = document.createElement('span');
							// 		jobDescriptionDiv.className = 'job-description';
							// 		jobDescriptionDiv.innerHTML = decodeHTMLEntities(data.jobDescription); // phpcs:ignore.
	
							// 		const anotherFieldDiv = document.createElement('span');
							// 		anotherFieldDiv.className = 'another-field';
							// 		anotherFieldDiv.innerHTML = decodeHTMLEntities(data.anotherField); // phpcs:ignore.
	
							// 		// Clear existing content
							// 		while (targetElement.firstChild) {
							// 			targetElement.removeChild(targetElement.firstChild);
							// 		}
	
							// 		// Append new content
							// 		targetElement.appendChild(jobDescriptionDiv); // phpcs:ignore.
							// 		targetElement.appendChild(anotherFieldDiv); // phpcs:ignore.
							// 	}
							// }
	
							// Function to decode HTML entities (assuming this function exists in your code)
							// function decodeHTMLEntities(str) {
							// 	const txt = document.createElement('textarea');
							// 	txt.innerHTML = str; // phpcs:ignore.
							// 	return txt.value;
							// }
	
							const loadMore = document.querySelector('.load-more');
							if (loadMore) {
								loadMore.addEventListener('click', event => {
									let cnt = 0;
									event.preventDefault();
									while (cnt < 5) {
										const row = document.querySelector('.ats-current-opening-dropdown.inactive');
										if (row !== null) {
											document
												.querySelector('.ats-current-opening-dropdown.inactive')
												.classList.remove('inactive');
										} else {
											console.error("Element with class 'my-class' not found.");
											document.querySelector('.openings-button').classList.add('inactive');
										}
										cnt += 1;
									}
								});
							}
	
							const atsJobOpeningElements = document.querySelectorAll(
								'.ats-current-opening-dropdown.item',
							);
							const applicationComplete = document.querySelector('.application-modal-index');
							const applicationCompleteClose = document.getElementById('complete-close');
							const applicationCompleteCloseButton = document.getElementById('complete-close-button');
							if (applicationCompleteClose) {
								applicationCompleteClose.addEventListener('click', () => {
									document.body.classList.remove('scroll-fix');
									if (applicationComplete) {
										applicationComplete.style.display = 'none';
									}
									window.location.reload();
								});
							}
							if (applicationCompleteCloseButton) {
								applicationCompleteCloseButton.addEventListener('click', () => {
									document.body.classList.remove('scroll-fix');
									if (applicationComplete) {
										applicationComplete.style.display = 'none';
									}
									window.location.reload();
								});
							}
							// Function to validate the file size
							function validateFileSize(fileInput) {
								const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
								const fileSize = fileInput.files[0].size;
								return fileSize <= maxSizeInBytes;
							}
							// Function to validate the file format
							function validateFileFormat(fileInput) {
								const allowedFormats = [
									'pdf',
									'doc',
									'docx',
									'ppt',
									'pptx',
									'jpg',
									'jpeg',
									'png',
									'gif',
									'zip',
									'webp',
								];
								const fileName = fileInput.value.toLowerCase();
								const fileExtension = fileName.split('.').pop();
								return allowedFormats.includes(fileExtension);
							}
							function validateForm(
								concentValidation,
								isCheckedConcent,
								fileValidationMessage,
								resumeFile,
								fileSizeValidationMessage,
								fileExsistsValidationMessage,
								selectElement,
							) {
								const resumeInput = resumeFile;
								const requiredInputs = document.querySelectorAll('.contact-dynamic input[required]');
								const fileValidation = fileValidationMessage;
								const checkedValidation = concentValidation;
								const sizeValidation = fileSizeValidationMessage;
								const fileExsists = fileExsistsValidationMessage;
								let empty = true;
								if (selectElement) {
									const selectValue = selectElement.value;
									const text = document.createElement('p');
									text.classList.add('contact-error');
									if (!selectValue) {
										empty = false;
									}
									if (!selectValue && !selectElement.nextElementSibling) {
										empty = false;
										const errorMessage = 'Please fill the required fields';
										const textContent = document.createTextNode(errorMessage);
										text.appendChild(textContent);
										selectElement.parentNode.appendChild(text);
									} else if (selectValue && selectElement.nextElementSibling) {
										selectElement.nextElementSibling.remove();
									}
								}
	
								requiredInputs.forEach(function (input) {
									const isChecked = isCheckedConcent.checked;
									const text = document.createElement('p');
									text.classList.add('contact-error');
									const val = input.value.trim();
									
									if (
										input.type !== 'checkbox' &&
										input.type !== 'file' &&
										input.nextElementSibling
									) {
										input.nextElementSibling.remove();
									}
									
									if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
										empty = false;
										const errorMessage = 'Please fill the required fields';
										const textContent = document.createTextNode(errorMessage);
										text.appendChild(textContent);
										input.parentNode.appendChild(text);
									}
									if (!resumeInput.files[0]) {
										fileExsists.style.display = 'block';
										empty = false;
									}
									if (input.type === 'file' && resumeInput.files[0]) {
										fileExsists.style.display = 'none';
										const fileFormat = validateFileFormat(resumeInput);
										const fileSize = validateFileSize(resumeInput);
										if (fileSize === false) {
											sizeValidation.style.display = 'block';
											empty = false;
										} else {
											sizeValidation.style.display = 'none';
										}
										if (fileFormat === false) {
											fileValidation.style.display = 'block';
											empty = false;
										} else {
											fileValidation.style.display = 'none';
										}
									}
									if(input.name === 'ats_mobile_number' && val.length < 10 && val.length !== 0 ){
										empty = false;
										const errorMessage = 'Please fill a valid mobile number.';
										const textContent = document.createTextNode(errorMessage);
										text.appendChild(textContent);
										input.parentNode.appendChild(text);
						
									}
									if(input.name === 'ats_email'  && val.length !== 0){
															
										const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
										const validEmail = pattern.test(val);
										if(!validEmail){
										empty = false;
						
											const errorMessage = 'Please fill a valid email address.';
											const textContent = document.createTextNode(errorMessage);
											text.appendChild(textContent);
											input.parentNode.appendChild(text);
										}
						
									}
									if (input.type === 'checkbox' && !isChecked) {
										empty = false;
										checkedValidation.style.display = 'block';
									} else if (input.type === 'checkbox' && isChecked) {
										checkedValidation.style.display = 'none';
									}
								});
								return empty;
							}
	
							function showCareerModal(careerModal, form, concentValidation) {
								const validation = concentValidation;
								const careerPopup = careerModal;
								form.classList.add('contact-dynamic');
								careerPopup.style.display = 'block';
								document.body.classList.add('scroll-fix');
								validation.style.display = 'none';
							}
	
							function hideCareerModal(careerModal, form) {
								const careerPopup = careerModal;
								form.classList.remove('contact-dynamic');
								document.body.classList.remove('scroll-fix');
								careerPopup.style.display = 'none';
							}
	
							function checkFormValidation(
								careerModal,
								form,
								concentValidation,
								isCheckedConcent,
								fileValidationMessage,
								resumeFile,
								fileSizeValidationMessage,
								fileExsistsValidationMessage,
								selectElement,
								formApplyButtonText,
							) {
								const careerPopup = careerModal;
								const applyButtontext = formApplyButtonText;
								if (
									validateForm(
										concentValidation,
										isCheckedConcent,
										fileValidationMessage,
										resumeFile,
										fileSizeValidationMessage,
										fileExsistsValidationMessage,
										selectElement,
									) === true
								) {
									applyButtontext.textContent = 'Applying...';
									applyButtontext.setAttribute('disabled', true);
									const formdata = new FormData();
									const file = resumeFile.files[0];
									const recaptchaToken = document.getElementById('recaptcha_token');
									const years = parseInt(form.ats_exp_years.value || 0, 10);
									const months = parseInt(form.ats_exp_month.value || 0, 10);
									// Convert months into fraction of a year
									const totalYears = years + (months / 12);
									const experienceInYears = parseFloat(totalYears.toFixed(1));
									formdata.append('file', file); // phpcs:ignore.
									formdata.append('name', form.ats_first_name.value); // phpcs:ignore.
									formdata.append('lastname', form.ats_last_name.value); // phpcs:ignore.
									formdata.append('email', form.ats_email.value); // phpcs:ignore.
									formdata.append('currCTC', form.ats_curr_ctc.value); // phpcs:ignore.
									formdata.append('expCTC', form.ats_exp_ctc.value); // phpcs:ignore.
									formdata.append('currLocation', form.ats_curr_loc.value); // phpcs:ignore.
									formdata.append('noticePeriod', form.ats_notice_p.value); // phpcs:ignore.
									formdata.append('mobile', form.ats_mobile_number.value); // phpcs:ignore.
									formdata.append('experience', experienceInYears); // phpcs:ignore.
									formdata.append('nonce', form.nonce.value); // phpcs:ignore.
									formdata.append('role', form.role.value); // phpcs:ignore.
									formdata.append('location', form.location.value); // phpcs:ignore.
									formdata.append('careerid', form.careerid.value); // phpcs:ignore.
									formdata.append('toMail', form.toMail.value); // phpcs:ignore.
									formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
									formdata.append('action', 'ats_career_form');
	
									fetch(
										ajaxload_params.ajaxurl, // eslint-disable-line
										{
											method: 'POST',
											body: formdata,
										},
									)
										.then(response => {
											if (!response.ok) {
												throw new Error('Network response was not ok');
											}
											return response.json(); // Parse the JSON response
										})
										.then(data => {
											if (data.success) {
												careerPopup.style.display = 'none';
												if (applicationComplete) {
													applicationComplete.style.display = 'flex';
												}
												document.body.classList.add('scroll-fix');
											} else {
												if (applicationComplete) {
													applicationComplete.style.display = 'flex';
												}
												console.error('Upload Failed:', data.message || 'No message returned.', data);
	
											}
										})
										.catch(error => {
											if (applicationComplete) {
												applicationComplete.style.display = 'flex';
											}
											console.error('Error:', error);
										});
								}
							}
	
							function uploadResume(fileInput, fileNameDisplay) {
								const fileName = fileNameDisplay;
								fileInput.click();
								fileInput.addEventListener('change', function () {
									const selectedFile = fileInput.files[0];
									if (selectedFile) {
										fileName.textContent = selectedFile.name;
									} else {
										fileName.textContent = '';
									}
								});
							}
	
							function copyCareerLink(copyLink) {
								const tooltip = copyLink;
								const link = copyLink.firstChild.getAttribute('href');
								const tempTextarea = document.createElement('textarea');
								tempTextarea.value = link;
								document.body.appendChild(tempTextarea);
								tempTextarea.select();
								document.execCommand('copy');
								document.body.removeChild(tempTextarea);
								tooltip.children[2].style.visibility = 'visible';
								setTimeout(function () {
									tooltip.children[2].style.visibility = 'hidden';
								}, 2000);
							}
	
							atsJobOpeningElements.forEach(jobOpeningElement => {
								const formSubmitAtsCurrentOpening = jobOpeningElement.querySelector(
									'#formSubmitAtsCurrentOpening',
								);
								
								const careerIndexModal = jobOpeningElement.querySelector('.ats-career-modal');
								const form = jobOpeningElement.querySelector('.ats-career-form-index');
								const atsFormSubmit = jobOpeningElement.querySelector('#formAtsSubmitIndex');
								const uploadButton = jobOpeningElement.querySelector('.ats-resume-upload-index');
								const fileNameDisplay = jobOpeningElement.querySelector('#ats-file-name-index');
								const copyLink = jobOpeningElement.querySelectorAll('.copyLink');
								const fileValidationMessage = jobOpeningElement.querySelector('.ats-validated-file');
								const concentValidation = jobOpeningElement.querySelector(
									'.ats-consent-validation-index',
								);
								const isCheckedConcent = jobOpeningElement.querySelector('.ats-consent-index');
								const resumeFile = jobOpeningElement.querySelector('.ats_resume_index');
								const fileSizeValidationMessage = jobOpeningElement.querySelector(
									'.ats-validated-file-size',
								);
								const fileExsistsValidationMessage = jobOpeningElement.querySelector(
									'.ats-validated-file-exists',
								);
								const selectElement = jobOpeningElement.querySelector('.ats_experience_index');
								const formApplyButtonText = jobOpeningElement.querySelector('.form-button-apply');
	
								if (concentValidation) {
									concentValidation.style.display = 'none';
								}
								if (fileValidationMessage) {
									fileValidationMessage.style.display = 'none';
								}
								if (fileSizeValidationMessage) {
									fileSizeValidationMessage.style.display = 'none';
								}
								if (fileExsistsValidationMessage) {
									fileExsistsValidationMessage.style.display = 'none';
								}
								copyLink.forEach(function (copy) {
									copy.addEventListener('click', () => {
										copyCareerLink(copy);
									});
								});
								formSubmitAtsCurrentOpening.addEventListener('click', () => {
									showCareerModal(careerIndexModal, form, concentValidation);
								});
								const closeIcon = jobOpeningElement.querySelector('#close-icon-index');
								closeIcon.addEventListener('click', () => {
									hideCareerModal(careerIndexModal, form);
								});
								atsFormSubmit.addEventListener('click', () => {
									checkFormValidation(
										careerIndexModal,
										form,
										concentValidation,
										isCheckedConcent,
										fileValidationMessage,
										resumeFile,
										fileSizeValidationMessage,
										fileExsistsValidationMessage,
										selectElement,
										formApplyButtonText,
									);
								});
								uploadButton.addEventListener('click', () => {
									const fileInput = uploadButton.previousElementSibling;
									uploadResume(fileInput, fileNameDisplay);
								});
							});
	
							grecaptcha.ready(function () {
								//eslint-disable-line
								grecaptcha //eslint-disable-line
									.execute(ajaxload_params.recaptchaSiteKey, { action: 'ats_career_form' }) //eslint-disable-line
									.then(function (token) {
										const tokenInput = document.createElement('input');
										tokenInput.type = 'hidden';
										tokenInput.id = 'recaptcha_token';
										tokenInput.name = 'recaptcha_token';
										tokenInput.value = token;
										const recaptchaContainer = document.getElementById('career-recaptcha');
										if (recaptchaContainer) {
											recaptchaContainer.innerHTML = ''; // Clear existing content
											recaptchaContainer.appendChild(tokenInput);
										}
									});
							});
						} else {
							console.error('Error:', response.data);
						}
					})
					.catch(error => console.error('Fetch error:', error));
			});

		}

	});

	const atsJobOpeningElements = document.querySelectorAll('.ats-current-opening-dropdown.item');
	const applicationComplete = document.querySelector('.application-modal-index');
	const applicationCompleteClose = document.getElementById('complete-close');
	const applicationCompleteCloseButton = document.getElementById('complete-close-button');
	if (applicationCompleteClose) {
		applicationCompleteClose.addEventListener('click', () => {
			document.body.classList.remove('scroll-fix');
			applicationComplete.style.display = 'none';
			window.location.reload();
		});
	}
	if (applicationCompleteCloseButton) {
		applicationCompleteCloseButton.addEventListener('click', () => {
			document.body.classList.remove('scroll-fix');
			applicationComplete.style.display = 'none';
			window.location.reload();
		});
	}
	// Function to validate the file size
	function validateFileSize(fileInput) {
		const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
		const fileSize = fileInput.files[0].size;
		return fileSize <= maxSizeInBytes;
	}
	// Function to validate the file format
	function validateFileFormat(fileInput) {
		const allowedFormats = [
			'pdf',
			'doc',
			'docx',
			'ppt',
			'pptx',
			'jpg',
			'jpeg',
			'png',
			'gif',
			'zip',
			'webp',
		];
		const fileName = fileInput.value.toLowerCase();
		const fileExtension = fileName.split('.').pop();
		return allowedFormats.includes(fileExtension);
	}
	function validateForm(
		concentValidation,
		isCheckedConcent,
		fileValidationMessage,
		resumeFile,
		fileSizeValidationMessage,
		fileExsistsValidationMessage,
		selectElement,
	) {
		const resumeInput = resumeFile;
		const requiredInputs = document.querySelectorAll('.contact-dynamic input[required]');
		const fileValidation = fileValidationMessage;
		const checkedValidation = concentValidation;
		const sizeValidation = fileSizeValidationMessage;
		const fileExsists = fileExsistsValidationMessage;
		let empty = true;
		if (selectElement) {
			const selectValue = selectElement.value;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			if (!selectValue) {
				empty = false;
			}
			if (!selectValue && !selectElement.nextElementSibling) {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				selectElement.parentNode.appendChild(text);
			} else if (selectValue && selectElement.nextElementSibling) {
				selectElement.nextElementSibling.remove();
			}
		}

		requiredInputs.forEach(function (input) {
			const isChecked = isCheckedConcent.checked;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			const val = input.value.trim();


			if (input.type !== 'checkbox' && input.type !== 'file' && input.nextElementSibling) {
				input.nextElementSibling.remove();
			}
			if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);
			}
			if (!resumeInput.files[0]) {
				fileExsists.style.display = 'block';
				empty = false;
			}
			if (input.type === 'file' && resumeInput.files[0]) {
				fileExsists.style.display = 'none';
				const fileFormat = validateFileFormat(resumeInput);
				const fileSize = validateFileSize(resumeInput);
				if (fileSize === false) {
					sizeValidation.style.display = 'block';
					empty = false;
				} else {
					sizeValidation.style.display = 'none';
				}
				if (fileFormat === false) {
					fileValidation.style.display = 'block';
					empty = false;
				} else {
					fileValidation.style.display = 'none';
				}
			}
			if(input.name === 'ats_mobile_number' && val.length < 10 && val.length !== 0 ){
				empty = false;
				const errorMessage = 'Please fill a valid mobile number.';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);

			}
			if(input.name === 'ats_email'  && val.length !== 0){
									
				const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				const validEmail = pattern.test(val);
				if(!validEmail){
				empty = false;

					const errorMessage = 'Please fill a valid email address.';
					const textContent = document.createTextNode(errorMessage);
					text.appendChild(textContent);
					input.parentNode.appendChild(text);
				}

			}
			if (input.type === 'checkbox' && !isChecked) {
				empty = false;
				checkedValidation.style.display = 'block';
			} else if (input.type === 'checkbox' && isChecked) {
				checkedValidation.style.display = 'none';
			}
		});
		return empty;
	}

	function showCareerModal(careerModal, form, concentValidation) {
		const validation = concentValidation;
		const careerPopup = careerModal;
		form.classList.add('contact-dynamic');
		careerPopup.style.display = 'block';
		document.body.classList.add('scroll-fix');
		validation.style.display = 'none';
	}

	function hideCareerModal(careerModal, form) {
		const careerPopup = careerModal;
		form.classList.remove('contact-dynamic');
		document.body.classList.remove('scroll-fix');
		careerPopup.style.display = 'none';
	}

	function checkFormValidation(
		careerModal,
		form,
		concentValidation,
		isCheckedConcent,
		fileValidationMessage,
		resumeFile,
		fileSizeValidationMessage,
		fileExsistsValidationMessage,
		selectElement,
		formApplyButtonText,
	) {
		const careerPopup = careerModal;
		const applyButtontext = formApplyButtonText;
		if (
			validateForm(
				concentValidation,
				isCheckedConcent,
				fileValidationMessage,
				resumeFile,
				fileSizeValidationMessage,
				fileExsistsValidationMessage,
				selectElement,
			) === true
		) {
			applyButtontext.textContent = 'Applying...';
			applyButtontext.setAttribute('disabled', true);
			const formdata = new FormData();
			const file = resumeFile.files[0];
			const recaptchaToken = document.getElementById('recaptcha_token');
			const years = parseInt(form.ats_exp_years.value || 0, 10);
			const months = parseInt(form.ats_exp_month.value || 0, 10);
			// Convert months into fraction of a year
			const totalYears = years + (months / 12);
			const experienceInYears = parseFloat(totalYears.toFixed(1));

			formdata.append('file', file); // phpcs:ignore.
			formdata.append('name', form.ats_first_name.value); // phpcs:ignore.
			formdata.append('lastname', form.ats_last_name.value); // phpcs:ignore.
			formdata.append('email', form.ats_email.value); // phpcs:ignore.
			formdata.append('currCTC', form.ats_curr_ctc.value); // phpcs:ignore.
			formdata.append('expCTC', form.ats_exp_ctc.value); // phpcs:ignore.
			formdata.append('currLocation', form.ats_curr_loc.value); // phpcs:ignore.
			formdata.append('noticePeriod', form.ats_notice_p.value); // phpcs:ignore.			
			formdata.append('mobile', form.ats_mobile_number.value); // phpcs:ignore.
			formdata.append('experience', experienceInYears); // phpcs:ignore.
			formdata.append('nonce', form.nonce.value); // phpcs:ignore.
			formdata.append('role', form.role.value); // phpcs:ignore.
			formdata.append('location', form.location.value); // phpcs:ignore.
			formdata.append('careerid', form.careerid.value); // phpcs:ignore.
			formdata.append('toMail', form.toMail.value); // phpcs:ignore.
			formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
			formdata.append('action', 'ats_career_form');

			fetch(
				ajaxload_params.ajaxurl, // eslint-disable-line
				{
					method: 'POST',
					body: formdata,
				},
			)
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.json(); // Parse the JSON response
				})
				.then(data => {
					if (data.success) {
						careerPopup.style.display = 'none';
						if (applicationComplete) {
							applicationComplete.style.display = 'flex';
						}
						document.body.classList.add('scroll-fix');
					} else {
						if (applicationComplete) {
							applicationComplete.style.display = 'flex';
						}
						document.body.classList.add('scroll-fix');
						console.error('Upload Failed:', data.message || 'No message returned.', data);

					}
				})
				.catch(error => {
					console.error('Error:', error);
					if (applicationComplete) {
						applicationComplete.style.display = 'flex';
					}
					document.body.classList.add('scroll-fix');
				});
		}
	}

	function uploadResume(fileInput, fileNameDisplay) {
		const fileName = fileNameDisplay;
		fileInput.click();
		fileInput.addEventListener('change', function () {
			const selectedFile = fileInput.files[0];
			if (selectedFile) {
				fileName.textContent = selectedFile.name;
			} else {
				fileName.textContent = '';
			}
		});
	}

	function copyCareerLink(copyLink) {
		const tooltip = copyLink;
		const link = copyLink.firstChild.getAttribute('href');
		const tempTextarea = document.createElement('textarea');
		tempTextarea.value = link;
		document.body.appendChild(tempTextarea);
		tempTextarea.select();
		document.execCommand('copy');
		document.body.removeChild(tempTextarea);
		tooltip.children[2].style.visibility = 'visible';
		setTimeout(function () {
			tooltip.children[2].style.visibility = 'hidden';
		}, 2000);
	}

	atsJobOpeningElements.forEach(jobOpeningElement => {
		const formSubmitAtsCurrentOpening = jobOpeningElement.querySelector(
			'#formSubmitAtsCurrentOpening',
		);
		const careerIndexModal = jobOpeningElement.querySelector('.ats-career-modal');
		const form = jobOpeningElement.querySelector('.ats-career-form-index');
		const atsFormSubmit = jobOpeningElement.querySelector('#formAtsSubmitIndex');
		const uploadButton = jobOpeningElement.querySelector('.ats-resume-upload-index');
		const fileNameDisplay = jobOpeningElement.querySelector('#ats-file-name-index');
		const copyLink = jobOpeningElement.querySelectorAll('.copyLink');
		const fileValidationMessage = jobOpeningElement.querySelector('.ats-validated-file');
		const concentValidation = jobOpeningElement.querySelector('.ats-consent-validation-index');
		const isCheckedConcent = jobOpeningElement.querySelector('.ats-consent-index');
		const resumeFile = jobOpeningElement.querySelector('.ats_resume_index');
		const fileSizeValidationMessage = jobOpeningElement.querySelector('.ats-validated-file-size');
		const fileExsistsValidationMessage = jobOpeningElement.querySelector(
			'.ats-validated-file-exists',
		);
		const selectElement = jobOpeningElement.querySelector('.ats_experience_index');
		const formApplyButtonText = jobOpeningElement.querySelector('.form-button-apply');

		if (concentValidation) {
			concentValidation.style.display = 'none';
		}
		if (fileValidationMessage) {
			fileValidationMessage.style.display = 'none';
		}
		if (fileSizeValidationMessage) {
			fileSizeValidationMessage.style.display = 'none';
		}
		if (fileExsistsValidationMessage) {
			fileExsistsValidationMessage.style.display = 'none';
		}
		copyLink.forEach(function (copy) {
			copy.addEventListener('click', () => {
				copyCareerLink(copy);
			});
		});
		formSubmitAtsCurrentOpening.addEventListener('click', () => {
			showCareerModal(careerIndexModal, form, concentValidation);
		});
		const closeIcon = jobOpeningElement.querySelector('#close-icon-index');
		closeIcon.addEventListener('click', () => {
			hideCareerModal(careerIndexModal, form);
		});
		atsFormSubmit.addEventListener('click', () => {
			checkFormValidation(
				careerIndexModal,
				form,
				concentValidation,
				isCheckedConcent,
				fileValidationMessage,
				resumeFile,
				fileSizeValidationMessage,
				fileExsistsValidationMessage,
				selectElement,
				formApplyButtonText,
			);
		});
		uploadButton.addEventListener('click', () => {
			const fileInput = uploadButton.previousElementSibling;
			uploadResume(fileInput, fileNameDisplay);
		});
	});

	grecaptcha.ready(function () {
		//eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'ats_career_form' }) //eslint-disable-line
			.then(function (token) {
				const tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;
				const recaptchaContainer = document.getElementById('career-recaptcha');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
			});
	});
	async function getSecureData() {
		try {
			const response = await fetch('/wp-json/infobeans/v1/get_talent_pool_api');
	
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
	
			const data = await response.json();
			return data;
	
		} catch (error) {
			return error
		}
	}
	
});

